export default "__VITE_ASSET__D9BnOGt9__";